import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useStaggeredAnimation } from '@/features/client-onboarding/hooks/use-staggered-animation';
import { useOnboardingNavigationActions } from '@/features/client-onboarding/stores/onboarding-navigation-store';

import { SessionType } from '@shared';
import { selectClient, selectSession } from '@/model';

export function useOverviewSlide(stepCount: number) {
  const client = useSelector(selectClient);
  const session = useSelector(selectSession);
  const { reset } = useOnboardingNavigationActions();

  const isClientSession = session.sessionType === SessionType.client;
  const clientHasNoAccess = isClientSession && client.hasAccessToResults !== true;

  const { visibleIndices, visibleLineIndices } = useStaggeredAnimation(stepCount, {
    baseDelay: 150,
    cardDuration: 350,
    lineDuration: 350,
  });

  useEffect(() => {
    reset();
  }, [reset]);

  return {
    clientFirstName: client.clientFirstName,
    clientHasNoAccess,
    visibleIndices,
    visibleLineIndices,
  };
}
